import { api_configuration } from "../../common";
import api_gui = api_configuration.libraries.gui_definition_lib.types.gui_model.alan_api;
import api_cs = api_configuration.types.client_state.alan_api;
import { gregorian_datetime_2_julian_datetime, gregorian_date_2_julian_date } from "../calendar/conversion";
import Gregorian_Date from "../calendar/Gregorian_Date";
import Gregorian_Datetime from "../calendar/Gregorian_Datetime";
import Hour_Time from "../calendar/Hour_Time";
import { ui_expression } from "./expressions";
import { getGuiNumber } from "../guiModel";
import * as Status from "../Status";
import { Scalar } from "../../../../../stream";

function getNumberLimit(number_limit: api_gui.Cnumber_limit): number {
	const type = number_limit.properties.type.state;
	switch (type.name) {
		case "dynamic": {
			const d = new Date();
			const greg_date = new Gregorian_Date(d.getFullYear(), d.getMonth() + 1, d.getDate());
			const base = type.node.properties.base.switch({
				now: () =>
					gregorian_datetime_2_julian_datetime(
						new Gregorian_Datetime(greg_date, new Hour_Time(d.getHours(), d.getMinutes(), d.getSeconds()))
					),
				today: () => gregorian_date_2_julian_date(greg_date),
			});
			const offset = type.node.properties.with_offset.switch({
				no: () => 0,
				yes: ($) => $.properties.offset.value,
			});
			return base + offset;
		}
		case "static":
			return type.node.properties.limit.value;
	}
}

export function getUpperLimit(property: api_cs.Cnumber__type__property): Scalar<number> | undefined {
	return getGuiNumber(property.inferences.number_type())?.properties.validation.properties.has_maximum.switch({
		no: () => undefined,
		yes: ($) => getNumberLimit($.properties.maximum),
		expression: ($) =>
			ui_expression<number>($.inferences.model_expression().properties.maximum).pipe((result) =>
				!Status.isResolved(result) ? Number.MAX_SAFE_INTEGER : result
			)([property.component_root, null, property.parent]),
	});
}

export function getLowerLimit(property: api_cs.Cnumber__type__property): Scalar<number> | undefined {
	return getGuiNumber(property.inferences.number_type())?.properties.validation.properties.has_minimum.switch({
		no: () => undefined,
		yes: ($) => getNumberLimit($.properties.minimum),
		expression: ($) =>
			ui_expression<number>($.inferences.model_expression().properties.minimum).pipe((result) =>
				!Status.isResolved(result) ? Number.MIN_SAFE_INTEGER : result
			)([property.component_root, null, property.parent]),
	});
}

export function mustBePositive(property: api_cs.Cnumber__type__property): boolean {
	return property.inferences.number_type().properties.set_type.switch({
		integer: false,
		positive: true,
	});
}
